module.exports = __webpack_public_path__ + "img/user_photo.4f66c91f.svg";